<template>
    <div class="i-smart-select">
        <inputi :placeholder="placeholder" v-model="search" @click="onFocus" @blur="onBlur" :label="label" :required="required" :hint="hint" />
        <div class="list-box" v-if="opened">
            <div class="list-item" v-for='o in options_filtered' @mousedown="select(o)">
                {{o.label}}
            </div>
        </div>
    </div>
</template>
<script>
import Inputi from "../inputi.vue";
export default {
    components: {
        Inputi
    },
    methods: {
        select(o) {
            this.search = o.label;
            this.opened = false;
            this.selected = o;
            this.$emit('input', o.value);
        },
        onFocus() {
            this.opened = true;
            if (this.selected) {
                this.search = "";
            }
        },
        onBlur(e) {
            this.opened = false;
            if (this.selected) {
                this.search = this.selected.label;
            } else {
                this.search = "";
            }
        }
    },
    mounted() {
        let { value, options } = this;
        this._options = options;
        if(typeof options == 'function'){
            this._options = options();
        }
        if (value) {
            let found = options.find(o => o.value === value);
            if (found) {
                this.selected = found;
                this.search = this.selected.label;
            }
        }
    },
    name: 'i-smart-select',
    props: {
        options: { type: Array },
        value: { type: [String, Number, Boolean] },
        required: { type: Boolean, default: false },
        placeholder: { type: String, default: "Начните печатать" },
        hint: { type: String },
        label: { type: String }
    },
    computed: {
        options_filtered() {
            return this.options.filter((o) => { return o.label.toLowerCase().indexOf(this.search.toLowerCase()) != -1 }) //.slice(0, 10)
        }
    },
    data() {
        return {
            opened: false,
            selected: false,
            search: ""
        }
    }
}
</script>
<style lang="css" scoped>
.i-smart-select {
    position: relative;
}

.list-box {
    position: fixed;
    background: white;
    z-index: 1001;
    border: 1px solid lightgrey;
    margin-top: -9px;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: scroll;
}

.list-item {
    padding: 4px 8px;
    border-bottom: 1px dashed lightgrey;
}

.list-item:last-child{
    border-bottom: none;
}

.list-item:hover {
    background: whitesmoke;
    cursor: pointer;
}
</style>